import Medusa from "@medusajs/js-sdk";
import { Opticomm } from "@sgflabs/opticomm-sdk";

export const backendUrl = __BACKEND_URL__ ?? "/";

const decodeJwt = (token: string) => {
  try {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload));

    return decoded;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string | null) => {
  if (!token) {
    return true;
  }

  const payload = decodeJwt(token);

  if (!payload?.exp) {
    return true;
  }

  return payload.exp * 1000 < Date.now();
};

export const getAuthToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage.getItem("medusa_auth_token");
};

export const sdk = new Medusa({
  baseUrl: backendUrl,
});

// Typed Opticomm SDK client for custom `/admin` routes (e.g. po-settings,
// purchase-orders refund) — same baseUrl/auth as `sdk` above, no extra
// `auth` config so it keeps js-sdk's default session/cookie behavior.
export const opticomm = new Opticomm({
  baseUrl: backendUrl,
});

// useful when you want to call the BE from the console and try things out quickly
if (typeof window !== "undefined") {
  (window as any).__sdk = sdk;
}
